import {MapImgNavigatableIndicatorChart} from "./MapImgNavigatableIndicatorChart";

/**
 * A container for a soil moisture indicator chart
 * @extends MapImgNavigatableIndicatorChart
 * @hideconstructor
 */
class SMIANChart extends MapImgNavigatableIndicatorChart {

    getClassName() {
        return "SMIANChart";
    }

    _extractChartData(dataFromService) {
        return dataFromService.features[0].properties.hist.SoilMoisture;
    }
}

export {SMIANChart}